document.addEventListener('DOMContentLoaded', function () {
  const accordionHeaders = document.querySelectorAll('.collapsible__button');

  accordionHeaders.forEach(header => {
    header.addEventListener('click', function (event) {
      const collapsibleTab = event.target.closest('.collapsible__item');
      const collapsibleContent = collapsibleTab.querySelector('.collapsible__content');
      const plusIcon = collapsibleTab.querySelector('.plus-icon');
      const minusIcon = collapsibleTab.querySelector('.minus-icon');

      if (collapsibleContent.hasAttribute('hidden')) {
        collapsibleContent.removeAttribute('hidden');
        collapsibleTab.setAttribute('open', 'true');
        plusIcon.setAttribute('hidden', '');
        minusIcon.removeAttribute('hidden');
      } else {
        collapsibleContent.setAttribute('hidden', '');
        collapsibleTab.removeAttribute('open');
        plusIcon.removeAttribute('hidden');
        minusIcon.setAttribute('hidden', '');
      }
    });
  });
});
